import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Headr from "./Headr";
import Services from "./Services";
import Soon from "./Soon";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <div className="bdy">
    <div className="navbar">
      <App />
      <Headr />
    </div>
    <Services />
    <Soon />
  </div>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
